<template>
  <b-card no-body v-if="stats">
    <b-card-header>
      <h3 class="mb-0">{{ new Date(stats.end_date).getFullYear() }} TRANSACTION STATS</h3>
    </b-card-header>
    <b-row>
      <b-col>
        <b-table responsive small striped hover :items="stats.stats" :fields="fields" foot-clone>
          <template #thead-top="data">
            <b-tr>
              <b-th>{{ new Date(stats.end_date).getFullYear() }} QUARTERLY GOALS</b-th>
              <b-th colspan="2" class="text-center">{{ stats.formatted_start_date }} &ndash; {{ stats.formatted_end_date }}</b-th>
            </b-tr>
          </template>

          <template #cell(quarter)="data">
            <strong>{{ data.item.quarter }}</strong>
          </template>

          <template #cell(closings)="data">
            {{ Math.round(data.item.estimated_closings) }}
          </template>

          <template #cell(volume)="data">
            {{ data.item.estimated_volume | currency }}
          </template>

          <template #cell(gci)="data">
            {{ data.item.estimated_gci | currency }}
          </template>

          <template #cell(profits)="data">
            {{ data.item.estimated_profits | currency }}
          </template>

          <template #foot(quarter)="data">
            Totals:
          </template>

          <template #foot(closings)="data">
            {{ estimatedUnits }}
          </template>

          <template #foot(volume)="data">
            {{ estimatedVolume | currency }}
          </template>

          <template #foot(gci)="data">
            {{ estimatedGci | currency }}
          </template>

          <template #foot(profits)="data">
            {{ estimatedProfit | currency }}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table responsive small striped hover :items="stats.stats" :fields="fields" foot-clone>
          <template #thead-top="data">
            <b-tr>
              <b-th>{{ new Date(stats.end_date).getFullYear() }} ACTUAL STATS</b-th>
              <b-th colspan="4" class="text-center" variant="danger">{{ stats.formatted_start_date }} &ndash; {{ stats.formatted_end_date }}</b-th>
            </b-tr>
          </template>

          <template #cell(quarter)="data">
            <strong>{{ data.item.quarter }}</strong>
          </template>

          <template #cell(closings)="data">
            {{ Math.round(data.item.closings) }}
          </template>

          <template #cell(volume)="data">
            {{ data.item.volume | currency }}
          </template>

          <template #cell(gci)="data">
            {{ data.item.gci | currency }}
          </template>

          <template #cell(profits)="data">
            {{ data.item.profits | currency }}
          </template>

          <template #foot(quarter)="data">
            Totals:
          </template>

          <template #foot(closings)="data">
            {{ totalUnits }}
          </template>

          <template #foot(volume)="data">
            {{ totalVolume | currency }}
          </template>

          <template #foot(gci)="data">
            {{ totalGci | currency }}
          </template>

          <template #foot(profits)="data">
            {{ totalProfit | currency }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  props: {
    stats: null
  },
  data: function() {
    return {
      fields: [
        {
          key: 'quarter'
        },
        {
          key: 'closings',
          label: 'Pending/Closed',
          variant: 'danger'
        },
        {
          key: 'volume',
          variant: 'danger'
        },
        {
          key: 'gci',
          label: 'GCI',
          variant: 'danger'
        },
        {
          key: 'profits',
          label: 'Profits',
          variant: 'danger'
        }
      ],
    }
  },
  computed: {
    estimatedUnits() {
      return this.stats.stats.reduce(function (total, value) {
        return total + Math.round(value.estimated_closings);
      }, 0);
    },
    estimatedVolume() {
      return this.stats.stats.reduce(function (total, value) {
        return total + Number(value.estimated_volume);
      }, 0);
    },
    estimatedGci() {
      return this.stats.stats.reduce(function (total, value) {
        return total + Number(value.estimated_gci);
      }, 0);
    },
    estimatedProfit() {
      return this.stats.stats.reduce(function (total, value) {
        return total + Number(value.estimated_profit);
      }, 0);
    },
    totalUnits() {
      return this.stats.stats.reduce(function (total, value) {
        return total + Number(value.closings);
      }, 0);
    },
    totalVolume() {
      return this.stats.stats.reduce(function (total, value) {
        return total + Number(value.volume);
      }, 0);
    },
    totalGci() {
      return this.stats.stats.reduce(function (total, value) {
        return total + Number(value.gci);
      }, 0);
    },
    totalProfit() {
      return this.stats.stats.reduce(function (total, value) {
        return total + Number(value.profits);
      }, 0);
    }
  }
};
</script>